import type { Directive, DirectiveBinding, VNode, VueElement } from 'vue';

interface ExtendedDirectiveBinding extends DirectiveBinding {
    event: (event: Event) => void;
}

const clickOutside: Directive = {
    beforeMount: function (el: VueElement, binding: DirectiveBinding, _vnode: VNode): void {
        const extendedBinding = binding as ExtendedDirectiveBinding;
        extendedBinding.event = function (event: Event): void {
            if (!(el === event.target || el.contains(event?.target as Node | null))) {
                if (extendedBinding.value instanceof Function) {
                    extendedBinding.value(event);
                }
            }
        };
        document.body.addEventListener('click', extendedBinding.event);
    },

    unmounted: function (_el: VueElement, binding: DirectiveBinding, _vnode: VNode): void {
        const extendedBinding = binding as ExtendedDirectiveBinding;
        document.body.removeEventListener('click', extendedBinding.event);
    },
};

export default clickOutside;
